"use client";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Contact from "./pages/Contact";
import Payment from "./pages/Payment";
import CourseDetail from "./pages/CourseDetail";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import Shipping from "./pages/Shipping";
import CompetencyTraining from "./pages/CompetencyTraining";
import AdminPage from "./pages/Login";
import AdminEnrollments from "./pages/AdminEnrollments";
import AuthorisedOffices from "./pages/AuthorisedOffices";
import CrewManagement from "./pages/CrewManagement";
import TechnicalServices from "./pages/TechnicalServices";
import RegistrySurvey from "./pages/RegistrySurvey";
import ShipInsurance from "./pages/ShipInsurance";
import ShipChartering from "./pages/ShipChartering";
import ShipBrokering from "./pages/ShipBrokering";
import OurFleet from "./pages/OurFleet";

import "./index.css";
import CadetshipTraining from "./pages/CadetshipTraining";

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/courses" element={<Courses />} />
          <Route
            path="/courses/competency-training"
            element={<CompetencyTraining />}
          />
          <Route
            path="/courses/cadetship-training"
            element={<CadetshipTraining />}
          />
          <Route path="/courses/:category" element={<CourseDetail />} />
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/adminEnrollments" element={<AdminEnrollments />} />
          <Route path="/login" element={<AdminPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/shipping" element={<Shipping />} />
          {/* <Route
            path="/services/vessel-registration"
            element={<VesselRegistration />}
          />
          <Route
            path="/services/yacht-registration"
            element={<YachtRegistration />}
          />
          <Route path="/services/maritime-labor" element={<MaritimeLabor />} />
          <Route
            path="/services/officer-licensing"
            element={<OfficerLicensing />}
          />
          <Route path="/services/seaman-book" element={<SeamanBook />} />
          <Route path="/services/filing-agents" element={<FilingAgents />} />
          <Route
            path="/services/officer-licensing/deck-officers"
            element={<DeckOfficers />}
          />
          <Route
            path="/services/officer-licensing/engineering-officers"
            element={<EngineeringOfficers />}
          />
          <Route
            path="/services/officer-licensing/hospitality"
            element={<Hospitality />}
          />
          <Route path="/services/officer-licensing/cadet" element={<Cadet />} />
          <Route path="/services/officer-licensing/ab" element={<Ab />} />
          <Route
            path="/services/officer-licensing/ii-officer"
            element={<IIofficer />}
          />
          <Route
            path="/services/officer-licensing/chief-officer"
            element={<ChiefOfficer />}
          />
          <Route
            path="/services/officer-licensing/captain"
            element={<Captain />}
          />
          <Route
            path="/services/officer-licensing/electrotechnical-certifications"
            element={<ElectrotechnicalCertifications />}
          />
          <Route
            path="/services/officer-licensing/rating-certifications"
            element={<RatingCertifications />}
          />
          <Route
            path="/services/ship-officer-crew"
            element={<ShipOfficerCrew />}
          /> */}

          <Route path="/authorised-offices" element={<AuthorisedOffices />} />
          <Route path="/crew-management" element={<CrewManagement />} />
          <Route path="/technical-services" element={<TechnicalServices />} />
          <Route path="/registry-survey" element={<RegistrySurvey />} />
          <Route path="/ship-insurance" element={<ShipInsurance />} />
          <Route path="/ship-chartering" element={<ShipChartering />} />
          <Route path="/ship-brokering" element={<ShipBrokering />} />
          <Route path="/our-fleet" element={<OurFleet />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export default App;
